import { useContext } from 'react';
import CurrentClientProfileContext from "./CurrentClientProfileContext";

export default () => useContext(CurrentClientProfileContext);
